import React from "react"
import { LoadingIndicator } from "components/LoadingIndicator"
import { Row, Col } from "reactstrap"
import ReactDragListView from "react-drag-listview/lib/index.js"
import Table from "components/Table"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { updateEventOrder, setEventsSortOptions } from "store/actions"
import { withRouter } from "react-router-dom"

const ExperiencesTable = ({
  isEventsLoaded,
  showLoadingIndicator,
  vendorId,
  updateEventOrder,
  eventsSortOptions,
  handleDeleteEventAction,
  columns,
  tableData,
  history,
  onClickCloneExpAction,
}) => {
  const actions = [
    {
      name: "Analytics",
      onClick: item => {
        history.push(`/event-reports/${item?.id}`)
      },
      icon: "bx bx-line-chart",
      isAvailable: true,
    },
    {
      name: "Edit",
      onClick: item => {
        history.push(`/events/${item?.vendor_id}/${item?.id}`)
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Clone",
      onClick: item => {
        onClickCloneExpAction(item)
      },
      icon: "bx bx-copy",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: handleDeleteEventAction,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const onDragEnd = (fromIndex, toIndex, type, index) => {
    if (toIndex < 0 || eventsSortOptions.o !== "order") return
    if (type === "LIST_ITEM") {
      const modifiedData = [...tableData].sort((a, b) => a.order - b.order)

      const item = modifiedData.splice(fromIndex, 1)[0]
      modifiedData.splice(toIndex, 0, item)

      const events = modifiedData
        .map((event, position) => {
          if (
            modifiedData[position].id !==
              tableData.sort((a, b) => a.order - b.order)[position].id ||
            modifiedData[position].order === 0
          ) {
            return {
              event_id: event.id,
              order: position + 1,
            }
          } else {
            return null
          }
        })
        .filter(event => event)
      updateEventOrder({
        category_id: null,
        events: events,
        vendor_id: parseInt(vendorId),
      })
    }
  }

  const renderTable = () => (
    <Table
      loadingData={showLoadingIndicator}
      sort={{ dataField: eventsSortOptions.o, order: eventsSortOptions.od }}
      actions={actions}
      noDataIndication={
        <div className="p-2 text-center">There is no data to display</div>
      }
      data={tableData}
      columns={columns}
    />
  )

  return (
    <React.Fragment>
      <Row>
        <Col>
          {!isEventsLoaded ? (
            <LoadingIndicator />
          ) : eventsSortOptions.o === "order" ? (
            <ReactDragListView
              nodeSelector="tr"
              handleSelector="tr"
              onDragEnd={(fromIndex, toIndex) =>
                onDragEnd(fromIndex, toIndex, "LIST_ITEM")
              }
            >
              {renderTable()}
            </ReactDragListView>
          ) : (
            renderTable()
          )}
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isEventsLoaded: state.experiences.isEventsLoaded,
  showLoadingIndicator: state.experiences.showLoadingIndicator,
  clientConfig: state.Login.clientConfig,
  vendorId: state.Login.vendorId,
  eventsSortOptions: state.experiences.eventsSortOptions,
  clientConfig: state.Login.clientConfig,
})

const mapDispatchToProps = dispatch => ({
  updateEventOrder: value => dispatch(updateEventOrder(value)),
  setEventsSortOptions: sortOptions =>
    dispatch(setEventsSortOptions(sortOptions)),
})

ExperiencesTable.propTypes = {
  handleDeleteEventAction: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ExperiencesTable))
